"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRentSpreeUserToken = void 0;
function isRentSpreeUserToken(value) {
    return value.access_token !== undefined;
}
exports.isRentSpreeUserToken = isRentSpreeUserToken;
//# sourceMappingURL=is-rentspree-user-token.js.map